import { FC } from 'react';
import ConstitutionAI from 'modules/_shared/components/OpenAI/Constitution';

import '../Modals.scss';
import CustomLoading from '../../CustomLoading';
import ConstitutionModalHeader from './components/ConstitutionModalHeader';
import ConstitutionModalBody from './components/ConstitutionModalBody';
import ConstitutionModalFooter from './components/ConstitutionModalFooter';
import { useConstitutionModal } from './context/ConstitutionModalContext';

const ConstitutionModal: FC = () => {
  const { data } = useConstitutionModal();

  return (
    <>
      <ConstitutionModalHeader />
      <ConstitutionModalBody />
      <ConstitutionModalFooter />

      {/* Add AI section */}
      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default ConstitutionModal;
